<template>
  <div class="d-flex align-items-center">
    <button
      v-if="data && data != '-' && (data.length > 0 || data == 'expected')"
      v-b-modal="'dashboardCompliances'"
      @click="setActionData()"
      class="d-flex align-items-center btn-primary type-text cursor-pointer"
    >
      <span class="comp-details cursor-pointer">{{
        $t("common.details")
      }}</span>
    </button>
    <span v-else>-</span>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["data", "user_id", "visit_id", "entity_id", "scan", "scan_id"],
  methods: {
    ...mapActions("modal", ["setData"]),
    ...mapActions("compliance", ["fetchComplianceUserDetails"]),
    setActionData() {
      console.log("CompliancesCell", this.data, this.scan);
      this.setData(this.data);
      let obj = {
        user_id: this.user_id,
        entity_id: this.entity_id,
        scan_id: this.scan_id,
      };

      this.fetchComplianceUserDetails(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.type-text {
  justify-content: center;
  width: 70px;
  height: 25px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  border: none;
  border-radius: 12.5px;
}
.details-icon {
  font-size: 1.1rem;
  cursor: pointer;
  outline: none;
}
</style>
